import {LocationalOverview} from "../integration/representation/feature";

const collator = new Intl.Collator("nb", {numeric: true});

export function toRoadList(locationals: LocationalOverview): string {

    if (locationals?.locationals) {
        let roadSet = new Set<string>();
        locationals.locationals.forEach(l => roadSet.add(l.road));
        let roads = [...roadSet];
        roads.sort(collator.compare);
        return roads.join(", ");
    } else {
        return "";
    }
}
